import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import qbBtnDefault from "../../../../assets/images/quickbooks/C2QB_green_btn_tall_default.svg";
import quickbooksLogo from "../../../../assets/images/quickbooks/QuickBooks Logo_Horz_Rev.png";
import quickbooksLightLogo from "../../../../assets/images/quickbooks/QuickBooks Logo_Horz.png";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IGetPriceGroupsDTO from "../../../../models/DTO/IGetPriceGroupsDTO";
import ILoadUserDTO from "../../../../models/DTO/ILoadUserDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetPriceGroupsDTO from "../../../../models/DTO/IOnGetPriceGroupsDTO";
import IOnLoadUserDTO from "../../../../models/DTO/IOnLoadUserDTO";
import IOnQBOGetIncomeAccountsDTO from "../../../../models/DTO/IOnQBOGetIncomeAccountsDTO";
import IOnQBOGetTermsDTO from "../../../../models/DTO/IOnQBOGetTermsDTO";
import IOnQBOSetCatalogItemIncomeAccountDTO from "../../../../models/DTO/IOnQBOSetCatalogItemIncomeAccountDTO";
import IOnQBOSetDefaultPOFieldDTO from "../../../../models/DTO/IOnQBOSetDefaultPOFieldDTO";
import IOnQBOSetDefaultSalesTermDTO from "../../../../models/DTO/IOnQBOSetDefaultSalesTermDTO";
import IOnUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IOnUpdateSupplierIntegrationsDTO";
import IQBOGetAccountsDTO from "../../../../models/DTO/IQBOGetAccountsDTO";
import IQBOOnGetAccountsDTO from "../../../../models/DTO/IQBOOnGetAccountsDTO";
import IQBOOnGetOtherCurrentAssetAccountsDTO from "../../../../models/DTO/IQBOOnGetOtherCurrentAssetAccountsDTO";
import IQBOOnOAuthDisconnectDTO from "../../../../models/DTO/IQBOOnOAuthDisconnectDTO";
import IQBOOnOAuthStartDTO from "../../../../models/DTO/IQBOOnOAuthStartDTO";
import IQBOSetCatalogItemIncomeAccountDTO from "../../../../models/DTO/IQBOSetCatalogItemIncomeAccountDTO";
import IQBOSetDefaultPOFieldDTO from "../../../../models/DTO/IQBOSetDefaultPOFieldDTO";
import IQBOSetDefaultSalesTermDTO from "../../../../models/DTO/IQBOSetDefaultSalesTermDTO";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ICatalog from "../../../../models/ICatalog";
import INotification from "../../../../models/INotification";
import IPrice_Group from "../../../../models/IPrice_Group";
import ISupplier_Integration from "../../../../models/ISupplier_Integration";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import QBOAccountTypeEnum from "../../../../models/QBOAccountTypeEnum";
import IQBOAccountDTO from "../../../../models/QuickBooks Online/IQBOAccountDTO";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwBadge from "../../../shared/OwBadge/OwBadge";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import WhatsThis from "../../../shared/WhatsThis/WhatsThis";
import "./QuickbooksConnect.scss";
import IQBOGetPreferencesDTO from "../../../../models/DTO/IQBOGetPreferencesDTO";
import IQBOOnGetPreferencesDTO from "../../../../models/DTO/IQBOOnGetPreferencesDTO";
import OwTextArea from "../../../shared/OwTextArea/OwTextArea";
import { Socket } from "socket.io-client";
import Typeahead from "../../../shared/Typeahead/Typeahead";
import ITypeaheadCatalogItemDTO from "../../../../models/DTO/ITypeaheadCatalogItemDTO";
import IOnTypeaheadCatalogItemDTO from "../../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import ICatalog_Item from "../../../../models/ICatalog_Item";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import IOnQBOGetCustomSalesFieldsDTO from "../../../../models/DTO/IOnQBOGetCustomSalesFieldsDTO";
import IQBOCustomFieldDTO from "../../../../models/QuickBooks Online/IQBOCustomFieldDTO";
import IQBOForceCustomFieldActiveDTO from "../../../../models/DTO/IQBOForceCustomFieldActiveDTO";
import QBOGroupedInvoiceTypeEnum from "../../../../models/QBOGroupedInvoiceTypeEnum";
import { isNil } from "lodash-es";
import QBOInvoiceDateFieldEnum from "@models/QBOInvoiceDateFieldEnum";
import QBOGlobalTaxCalculationEnum from "../../../../models/QBOGlobalTaxCalculationEnum";
import { OwIconTooltip } from "@components/shared/OwIconTooltip/OwIconTooltip";
import IOnQBOGetTaxCodesDTO from "@models/DTO/IOnQBOGetTaxCodesDTO";
import IQBOGetTaxCodesDTO from "@models/DTO/IQBOGetTaxCodesDTO";
import IQBOGetCustomFieldDefinitionsDTO from "@models/DTO/IQBOGetCustomFieldDefinitionsDTO";
import IOnQBOGetCustomFieldDefinitionsDTO from "@models/DTO/IOnQBOGetCustomFieldDefinitionsDTO";
import IQBOCustomFieldDefinition from "@models/QuickBooks Online/IQBOCustomFieldDefinition";
import IQBOCustomFieldMapping from "@models/QuickBooks Online/IQBOCustomFieldMapping";
import { IQBOMappableField } from "@models/QuickBooks Online/QBOMappableFields";
import IQBOGetMappableFieldsDTO from "@models/DTO/IQBOGetMappableFieldsDTO";
import IOnQBOGetMappableFieldsDTO from "@models/DTO/IOnQBOGetMappableFieldsDTO";
import IQBOSetCustomFieldMappingsDTO from "@models/DTO/IQBOSetCustomFieldMappingsDTO";
import IOnQBOSetCustomFieldMappingsDTO from "@models/DTO/IOnQBOSetCustomFieldMappingsDTO";
import CustomFieldMappings from "./CustomFieldMappings/CustomFieldMappings";

import { qboRepAssignmentOptions } from "../../../orders/QboPullInvoicesAsOrdersModal/QboReprocessOrderAssignments";
import { QBORepUserTarget } from "../../../../models/DTO/IQBOReprocessOrderRepAssignmentsDTO";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    isMainViewLight?: boolean;
    catalogs: ICatalog[];
    showHiddenFeatures: boolean;
};

type State = {
    qboOtherCurrentAssetAccounts: IQBOAccountDTO[];
    qboCOGSAccounts: IQBOAccountDTO[];
    qboIncomeAccounts: IQBOAccountDTO[];
    qboAPAccounts: IQBOAccountDTO[];
    qbo_InventoryAssetAccountId?: string;
    qbo_CatalogItemIncomeAcctId?: string;
    qbo_POCustomFieldId?: string;
    qbo_DefaultTermId?: string;
    showQboIncomeAccountHowTo: boolean;
    saveIncomeAcctActive: boolean;
    saveCustomFieldActive: boolean;
    saveTermFieldActive: boolean;
    qboTermOptions: any[];
    qboTermOptionsLoaded: boolean;
    showQboSalesTermsHowTo: boolean;
    qboCustomSalesFields: { Id: string | null; Name: string | undefined }[];
    qboRawCustomSalesFields: IQBOCustomFieldDTO[];
    qboCustomFieldDefinitions: IQBOCustomFieldDefinition[];
    qboPOFieldOptions: { Id: string; Name: string }[];
    getCustomFieldDefinitionsActive: boolean;
    qboMappableFields: IQBOMappableField[];
    qboCustomFieldMappings: IQBOCustomFieldMapping[];
    saveCustomFieldMappingsActive: boolean;
    showQboCustomSalesFieldsHowTo: boolean;
    incomeAccountComponent: any;
    poFieldComponent: any;
    termsComponent: any;
    catalogs: ICatalog[];
    priceGroups: IPrice_Group[];
    catalog_id?: number;
    price_group_id?: number;
    saveDefaultPriceGroupActive: boolean;
    qbo_RepGroupCustomFieldId?: string;
    qbo_SalesRepCustomFieldId?: string;
    saveInventoryAssetAcctActive: boolean;
    qbo_COGSAccountId?: string;
    qbo_COGSAccountName?: string;
    saveCOGSAccountActive: boolean;
    enable_payments: boolean;
    qbo_auto_pull_customers: boolean;
    qbo_auto_pull_products: boolean;
    qbo_auto_pull_categories: boolean;
    qbo_update_accounts_on_save: boolean;
    qbo_ow_num_as_invoice_ref: boolean;
    qbo_use_ow_quote_num_for_estimate: boolean;
    qbo_CustomFieldValueOne?: any;
    qbo_CustomFieldValueTwo?: any;
    qbo_CustomFieldValueThree?: any;
    qbo_UsingAutoSalesTax: boolean;
    saveDefaultTaxRateActive: boolean;
    saveAPAccountActive: boolean;
    activeAutoSalesTax: boolean;
    qbo_AllowAchPayments: boolean;
    qbo_using_classes: boolean;
    qbo_po_default_ap_account?: { Id: string; Name: string };
    qbo_hide_quote_ow_btns: boolean;
    qbo_quote_for_est_name: boolean;
    qbo_estimate_from_order: boolean;
    qbo_est_invoice_auto_ship: boolean;
    qbo_pull_assign_rep_user: boolean;
    qbo_pull_rep_user_target: QBORepUserTarget;
    qbo_invoice_memo?: string;
    foundShippingItems: ICatalog_Item[];
    selectedShippingItem?: ICatalog_Item | null;
    clearShippingItem: boolean;
    qbo_customer_name_field: "DisplayName" | "CompanyName" | null;
    qbo_grouped_invoices: boolean;
    // qbo_grouped_invoices_by_day: boolean;
    getCustomFieldsActive: boolean;
    qbo_grouped_invoice_type?: QBOGroupedInvoiceTypeEnum | null;
    qbo_invoice_default_date?: QBOInvoiceDateFieldEnum | null;
    qbo_invoice_default_ship_date?: QBOInvoiceDateFieldEnum | null;
    qbo_push_inventory_updates?: boolean;
    qbo_skip_inventory_updates?: boolean;
    qbo_GlobalTaxCalculationEnum?: QBOGlobalTaxCalculationEnum | null;
    qbo_TaxOnShippingAdjustment?: boolean;
    qbo_skip_category_assignment?: boolean;
    qbo_skip_category_sync?: boolean;
    qbo_Country?: "US" | "UK" | "CA" | "AU";
    saveCountryActive: boolean;
    qbo_DefaultShipMethodRefValue?: string;
    // Redesign: nested-accordion config groups, group-level dirty tracking and a single panel Save.
    qboOpenGroups: { [groupId: string]: boolean };
    qboDirtyGroups: string[];
    qboDirtyTargets: string[];
    qboSavingAll: boolean;
    // Which fields currently have their inline "What's this?" help expanded (keyed by field key).
    qboOpenHelp: { [fieldKey: string]: boolean };
};

// Save "targets" — each maps to one existing save handler / endpoint. The single panel Save only fires
// the targets whose fields actually changed (see QBO_FIELD_TARGET / saveAll).
type QboSaveTarget =
    | "country"
    | "terms"
    | "customFields"
    | "autoSalesTax"
    | "incomeAccount"
    | "inventoryAsset"
    | "cogs"
    | "apAccount"
    | "autoPull"
    | "priceGroup"
    | "salesRep"
    | "repGroup"
    | "poField";

// Each nested config group: icon (FA6 solid), translation key for its name and one-line description.
const QBO_GROUPS: { id: string; icon: string; label: string; desc: string }[] = [
    { id: "setup", icon: "fa-sliders", label: "setup", desc: "qbo_setup_desc" },
    { id: "items", icon: "fa-box", label: "items", desc: "qbo_items_desc" },
    { id: "customers", icon: "fa-users", label: "customers", desc: "qbo_customers_desc" },
    { id: "orders", icon: "fa-clipboard-list", label: "orders", desc: "qbo_orders_desc" },
    { id: "estimates", icon: "fa-file-lines", label: "estimates", desc: "qbo_sales_orders_desc" },
    { id: "invoices", icon: "fa-file-invoice-dollar", label: "invoices", desc: "qbo_invoices_desc" },
    { id: "mappings", icon: "fa-arrow-right-arrow-left", label: "qbo_custom_field_mappings", desc: "qbo_mappings_desc" },
    { id: "other", icon: "fa-ellipsis", label: "other", desc: "qbo_other_desc" },
];

// field state-name -> the group whose dirty-dot should light up when it changes.
const QBO_FIELD_GROUP: { [name: string]: string } = {
    qbo_Country: "setup",
    qbo_GlobalTaxCalculationEnum: "setup",
    catalog_id: "setup",
    price_group_id: "setup",
    qbo_UsingAutoSalesTax: "invoices",
    qbo_TaxOnShippingAdjustment: "invoices",
    qbo_CatalogItemIncomeAcctId: "items",
    qbo_InventoryAssetAccountId: "items",
    qbo_COGSAccountId: "items",
    qbo_po_default_ap_account: "items",
    qbo_auto_pull_products: "items",
    qbo_push_inventory_updates: "items",
    qbo_skip_inventory_updates: "items",
    qbo_skip_category_assignment: "items",
    qbo_skip_category_sync: "items",
    qbo_auto_pull_categories: "items",
    qbo_DefaultTermId: "customers",
    qbo_customer_name_field: "customers",
    qbo_auto_pull_customers: "customers",
    qbo_update_accounts_on_save: "customers",
    qbo_SalesRepCustomFieldId: "orders",
    qbo_SalesRepCustomFieldName: "orders",
    qbo_RepGroupCustomFieldId: "orders",
    qbo_RepGroupCustomFieldName: "orders",
    qbo_CustomFieldValueOne: "orders",
    qbo_CustomFieldValueTwo: "orders",
    qbo_CustomFieldValueThree: "orders",
    selectedShippingItem: "orders",
    qbo_use_ow_quote_num_for_estimate: "estimates",
    qbo_quote_for_est_name: "estimates",
    qbo_hide_quote_ow_btns: "estimates",
    qbo_estimate_from_order: "estimates",
    qbo_est_invoice_auto_ship: "estimates",
    qbo_pull_assign_rep_user: "invoices",
    qbo_pull_rep_user_target: "invoices",
    qbo_POCustomFieldId: "invoices",
    qbo_invoice_default_date: "invoices",
    qbo_invoice_default_ship_date: "invoices",
    qbo_invoice_memo: "invoices",
    qbo_ow_num_as_invoice_ref: "invoices",
    qbo_grouped_invoices: "invoices",
    qbo_grouped_invoice_type: "invoices",
    qbo_AllowAchPayments: "invoices",
    qbo_DefaultShipMethodRefValue: "invoices",
    qbo_using_classes: "other",
};

// field state-name -> which save endpoint commits it.
const QBO_FIELD_TARGET: { [name: string]: QboSaveTarget } = {
    qbo_Country: "country",
    qbo_DefaultTermId: "terms",
    qbo_GlobalTaxCalculationEnum: "customFields",
    qbo_UsingAutoSalesTax: "autoSalesTax",
    qbo_TaxOnShippingAdjustment: "autoSalesTax",
    qbo_CatalogItemIncomeAcctId: "incomeAccount",
    qbo_InventoryAssetAccountId: "inventoryAsset",
    qbo_COGSAccountId: "cogs",
    qbo_po_default_ap_account: "apAccount",
    qbo_auto_pull_products: "autoPull",
    qbo_push_inventory_updates: "autoPull",
    qbo_skip_inventory_updates: "autoPull",
    qbo_skip_category_assignment: "autoPull",
    qbo_skip_category_sync: "autoPull",
    qbo_auto_pull_categories: "autoPull",
    qbo_customer_name_field: "customFields",
    catalog_id: "priceGroup",
    price_group_id: "priceGroup",
    qbo_auto_pull_customers: "autoPull",
    qbo_SalesRepCustomFieldId: "salesRep",
    qbo_SalesRepCustomFieldName: "salesRep",
    qbo_RepGroupCustomFieldId: "repGroup",
    qbo_RepGroupCustomFieldName: "repGroup",
    qbo_CustomFieldValueOne: "customFields",
    qbo_CustomFieldValueTwo: "customFields",
    qbo_CustomFieldValueThree: "customFields",
    selectedShippingItem: "customFields",
    qbo_use_ow_quote_num_for_estimate: "customFields",
    qbo_quote_for_est_name: "customFields",
    qbo_hide_quote_ow_btns: "customFields",
    qbo_estimate_from_order: "customFields",
    qbo_est_invoice_auto_ship: "customFields",
    qbo_pull_assign_rep_user: "customFields",
    qbo_pull_rep_user_target: "customFields",
    qbo_POCustomFieldId: "poField",
    qbo_invoice_default_date: "customFields",
    qbo_invoice_default_ship_date: "customFields",
    qbo_invoice_memo: "customFields",
    qbo_ow_num_as_invoice_ref: "customFields",
    qbo_grouped_invoices: "customFields",
    qbo_grouped_invoice_type: "customFields",
    qbo_AllowAchPayments: "customFields",
    qbo_DefaultShipMethodRefValue: "customFields",
    qbo_using_classes: "autoPull",
    qbo_update_accounts_on_save: "autoPull",
};

class QuickbooksConnect extends Component<Props, State> {
    readonly state: State = {
        qboOtherCurrentAssetAccounts: [],
        qboCOGSAccounts: [],
        qboIncomeAccounts: [],
        qboAPAccounts: [],
        qboTermOptions: [],
        qboTermOptionsLoaded: false,
        qboCustomSalesFields: [],
        qboRawCustomSalesFields: [],
        qboCustomFieldDefinitions: [],
        qboPOFieldOptions: [],
        getCustomFieldDefinitionsActive: true,
        qboMappableFields: [],
        qboCustomFieldMappings: [],
        saveCustomFieldMappingsActive: false,
        saveIncomeAcctActive: false,
        saveCustomFieldActive: false,
        saveTermFieldActive: false,
        saveCOGSAccountActive: false,
        showQboIncomeAccountHowTo: false,
        showQboCustomSalesFieldsHowTo: false,
        showQboSalesTermsHowTo: false,
        incomeAccountComponent: null,
        poFieldComponent: null,
        termsComponent: null,
        catalogs: this.props.catalogs,
        priceGroups: [],
        saveDefaultPriceGroupActive: false,
        saveInventoryAssetAcctActive: false,
        enable_payments: true,
        qbo_auto_pull_customers: false,
        qbo_auto_pull_products: !!this.props.supplierModel.Supplier_Integration.qbo_auto_pull_products,
        qbo_auto_pull_categories: !!this.props.supplierModel.Supplier_Integration.qbo_auto_pull_categories,
        qbo_update_accounts_on_save: !!this.props.supplierModel.Supplier_Integration.qbo_update_accounts_on_save,
        qbo_CustomFieldValueOne: this.props.supplierModel.Supplier_Integration.qbo_CustomFieldOne,
        qbo_CustomFieldValueTwo: this.props.supplierModel.Supplier_Integration.qbo_CustomFieldTwo,
        qbo_CustomFieldValueThree: this.props.supplierModel.Supplier_Integration.qbo_CustomFieldThree,
        qbo_ow_num_as_invoice_ref: !isNil(this.props.supplierModel.Supplier_Integration.qbo_ow_num_as_invoice_ref)
            ? this.props.supplierModel.Supplier_Integration.qbo_ow_num_as_invoice_ref
            : true,
        qbo_UsingAutoSalesTax: this.props.supplierModel.Supplier_Integration.qbo_UsingAutoSalesTax || false,
        qbo_po_default_ap_account: this.props.supplierModel.Supplier_Integration.qbo_po_default_ap_account,
        saveDefaultTaxRateActive: false,
        activeAutoSalesTax: false,
        saveAPAccountActive: false,
        qbo_use_ow_quote_num_for_estimate: this.props.supplierModel.Supplier_Integration.qbo_use_ow_quote_num_for_estimate || false,
        qbo_AllowAchPayments: this.props.supplierModel.Supplier_Integration.qbo_AllowAchPayments || false,
        qbo_using_classes: this.props.supplierModel.Supplier_Integration.qbo_using_classes || false,
        qbo_hide_quote_ow_btns: this.props.supplierModel.Supplier_Integration.qbo_hide_quote_ow_btns || false,
        qbo_quote_for_est_name: this.props.supplierModel.Supplier_Integration.qbo_quote_for_est_name || false,
        qbo_estimate_from_order: this.props.supplierModel.Supplier_Integration.qbo_estimate_from_order || false,
        qbo_est_invoice_auto_ship: this.props.supplierModel.Supplier_Integration.qbo_est_invoice_auto_ship || false,
        qbo_pull_rep_user_target: this.props.supplierModel.Supplier_Integration.qbo_pull_rep_user_target || "user_id",
        qbo_pull_assign_rep_user: this.props.supplierModel.Supplier_Integration.qbo_pull_assign_rep_user || false,
        qbo_invoice_memo: this.props.supplierModel.Supplier_Integration.qbo_invoice_memo,
        foundShippingItems: [],
        selectedShippingItem: this.props.supplierModel.Supplier_Integration.QBO_Shipping_Catalog_Item || null,
        clearShippingItem: false,
        qbo_customer_name_field: this.props.supplierModel.Supplier_Integration.qbo_customer_name_field || null,
        qbo_grouped_invoices: this.props.supplierModel.Supplier_Integration.qbo_grouped_invoices || false,
        // qbo_grouped_invoices_by_day: this.props.supplierModel.Supplier_Integration.qbo_grouped_invoices_by_day || false,
        getCustomFieldsActive: true,
        qbo_grouped_invoice_type: this.props.supplierModel.Supplier_Integration.qbo_grouped_invoice_type || null,
        qbo_invoice_default_date: this.props.supplierModel.Supplier_Integration.qbo_invoice_default_date || null,
        qbo_invoice_default_ship_date: this.props.supplierModel.Supplier_Integration.qbo_invoice_default_ship_date || null,
        qbo_push_inventory_updates: this.props.supplierModel.Supplier_Integration.qbo_push_inventory_updates || false,
        qbo_GlobalTaxCalculationEnum: this.props.supplierModel.Supplier_Integration.qbo_GlobalTaxCalculationEnum || null,
        qbo_skip_inventory_updates: this.props.supplierModel.Supplier_Integration.qbo_skip_inventory_updates || false,
        qbo_TaxOnShippingAdjustment: this.props.supplierModel.Supplier_Integration.qbo_TaxOnShippingAdjustment || false,
        qbo_skip_category_assignment: this.props.supplierModel.Supplier_Integration.qbo_skip_category_assignment || false,
        qbo_skip_category_sync: this.props.supplierModel.Supplier_Integration.qbo_skip_category_sync || false,
        qbo_Country: this.props.supplierModel.Supplier_Integration.qbo_Country || "US",
        saveCountryActive: false,
        qbo_DefaultShipMethodRefValue: this.props.supplierModel.Supplier_Integration.qbo_DefaultShipMethodRefValue || "",
        qboOpenGroups: { setup: true },
        qboDirtyGroups: [],
        qboDirtyTargets: [],
        qboSavingAll: false,
        qboOpenHelp: {},
    };

    qboCountryOptions = [
        { title: "US", value: "US" },
        { title: "UK", value: "UK" },
        { title: "CA", value: "CA" },
        { title: "AU", value: "AU" },
    ];

    sockets: IUiSocketSetup[] = [];

    qboInvoiceDateFieldOptions = [
        { title: "delivery_date", value: QBOInvoiceDateFieldEnum.DELIVERY_DATE },
        { title: "ship_date", value: QBOInvoiceDateFieldEnum.SHIP_DATE },
        { title: "due_date", value: QBOInvoiceDateFieldEnum.DUE_DATE },
        { title: "do_not_ship_before_date", value: QBOInvoiceDateFieldEnum.DO_NOT_SHIP_BEFORE_DATE },
        // { title: "submit_date", value: QBOInvoiceDateFieldEnum.SUBMIT_DATE },
        // { title: "confirmed_date", value: QBOInvoiceDateFieldEnum.CONFIRMED_DATE },
    ];

    qboGlobalTaxCalcOptions = [
        { title: "not_applicable", value: QBOGlobalTaxCalculationEnum.NOT_APPLICABLE },
        { title: "tax_excluded", value: QBOGlobalTaxCalculationEnum.TAX_EXCLUDED },
        { title: "tax_inclusive", value: QBOGlobalTaxCalculationEnum.TAX_INCLUSIVE },
    ];

    constructor(props: any) {
        super(props);

        this.sockets = [
            { endpoint: EndpointsEnum.QBOOnOAuthStart, fn: this.onQboOauthStart },
            { endpoint: EndpointsEnum.QBOOnOAuthDisconnect, fn: this.onQboOauthDisconnect },
            { endpoint: EndpointsEnum.QBOOnGetIncomeAccounts, fn: this.onQboGetIncomeAccounts },
            { endpoint: EndpointsEnum.QBOOnGetAccounts, fn: this.onQboGetAccounts },
            { endpoint: EndpointsEnum.QBOOnGetOtherCurrentAssetAccounts, fn: this.onQboGetOtherCurrentAssetAccounts },
            { endpoint: EndpointsEnum.QBOOnSetCatalogItemIncomeAccount, fn: this.onQboSetCatalogItemIncomeAccount },
            { endpoint: EndpointsEnum.QBOOnSetDefaultSalesTerm, fn: this.onQboSetDefaultSalesTerm },
            { endpoint: EndpointsEnum.QBOOnSetDefaultPOField, fn: this.onQboSetDefaultPOField },
            { endpoint: EndpointsEnum.QBOOnGetSalesTerms, fn: this.onQboGetTerms },
            { endpoint: EndpointsEnum.QBOOnGetCustomSalesFields, fn: this.onQboGetCustomSalesFields },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.AppOnLoadUser, fn: this.onLoadUser },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: this.onGetCatalogs },
            { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: this.onGetPriceGroups },
            { endpoint: EndpointsEnum.SupplierOnUpdateSupplierIntegrations, fn: this.onUpdateSupplierIntegrations },
            { endpoint: EndpointsEnum.QBOOnGetPreferences, fn: this.onGetPreferences },
            { endpoint: EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, fn: this.onShippingItemLookup },
            { endpoint: EndpointsEnum.QBOOnForceCustomFieldActive, fn: this.onForceCustomFieldActive },
            { endpoint: EndpointsEnum.QBOOnGetTaxCodes, fn: this.onQboGetTaxCodes },
            { endpoint: EndpointsEnum.QBOOnGetCustomFieldDefinitions, fn: this.onQboGetCustomFieldDefinitions },
            { endpoint: EndpointsEnum.QBOOnGetMappableFields, fn: this.onQboGetMappableFields },
            { endpoint: EndpointsEnum.QBOOnSetCustomFieldMappings, fn: this.onQboSetCustomFieldMappings },
        ];
    }

    componentDidMount(): void {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        // @ts-expect-error
        let supplierIntegrations: ISupplier_Integration = {};

        if (!_.isNil(this.props.supplierModel)) {
            supplierIntegrations = this.props.supplierModel.Supplier_Integration || {};
        }

        const state: any = {
            qbo_CatalogItemIncomeAcctId: supplierIntegrations.qbo_CatalogItemIncomeAcctId,
            qbo_InventoryAssetAccountId: supplierIntegrations.qbo_InventoryAssetAccountId,
            qbo_COGSAccountId: supplierIntegrations.qbo_COGSAccountId,
            qbo_POCustomFieldId: supplierIntegrations.qbo_POCustomFieldId,
            qbo_DefaultTermId: supplierIntegrations.qbo_DefaultTermId,
            qbo_SalesRepCustomFieldId: supplierIntegrations.qbo_SalesRepCustomFieldId,
            qbo_RepGroupCustomFieldId: supplierIntegrations.qbo_RepGroupCustomFieldId,
            incomeAccountComponent: null,
            poFieldComponent: null,
            termsComponent: null,
            qbo_auto_pull_customers: supplierIntegrations.qbo_auto_pull_customers,
            qbo_auto_pull_products: supplierIntegrations.qbo_auto_pull_products,
            qbo_auto_pull_categories: !!supplierIntegrations.qbo_auto_pull_categories,
            qboCustomFieldMappings: supplierIntegrations.qbo_CustomFieldMappings ?? [],
        };

        if (this.props.supplierModel.Supplier_Integration.has_qbo) {
            state.incomeAccountComponent = this.getIncomeAccountSelection();
            state.poFieldComponent = this.poCustomField();
            state.termsComponent = this.getDefaultSalesTerms();
        }

        this.setState(state, () => {
            if (supplierIntegrations.has_qbo) {
                this.props.socket.emit(EndpointsEnum.QBOGetCustomSalesFields, this.getQboPayload());
                if (supplierIntegrations.qbo_useEnhancedCustomFields) {
                    this.getCustomFieldDefinitions();
                    this.getMappableFields();
                }
                this.props.socket.emit(EndpointsEnum.QBOGetIncomeAccounts, this.getQboPayload());
                this.props.socket.emit(EndpointsEnum.QBOGetSalesTerms, this.getQboPayload());
                this.props.socket.emit(EndpointsEnum.QBOGetOtherCurrentAssetAccounts, this.getQboPayload());

                this.getCOGSAccounts();
                this.qboGetAccounts(QBOAccountTypeEnum.ACCOUNTS_PAYABLE);
            }
        });
    }

    componentWillUnmount(): void {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    getCustomFieldDefinitions = () => {
        const payload: IQBOGetCustomFieldDefinitionsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetCustomFieldDefinitions, payload);
    };

    // The definitions are pre-fetched into state on load, so just log what we have.
    logCustomFieldDefinitions = () => {
        console.log("qboCustomFieldDefinitions: ", this.state.qboCustomFieldDefinitions);
        console.log("qboPOFieldOptions: ", this.state.qboPOFieldOptions);
    };

    isEnhancedCustomFields = () => {
        return !!this.props.supplierModel.Supplier_Integration.qbo_useEnhancedCustomFields;
    };

    // Definitions that can be written to an invoice — those associated with a QBO transaction. Falls back to
    // all active definitions so the dropdowns are never empty. Shared by the PO field list and the mappings editor.
    getInvoiceApplicableDefinitions = (definitions: IQBOCustomFieldDefinition[]): IQBOCustomFieldDefinition[] => {
        const appliesToInvoices = definitions.filter((definition) =>
            (definition.associations ?? []).some(
                (association) => association.associatedEntity?.includes("/transactions/Transaction") && association.active === true
            )
        );

        return appliesToInvoices.length ? appliesToInvoices : definitions.filter((definition) => definition.active);
    };

    onQboGetCustomFieldDefinitions = (data: IOnQBOGetCustomFieldDefinitionsDTO) => {
        const definitions = data.customFieldDefinitions ?? [];

        const selectedDefinitions = this.getInvoiceApplicableDefinitions(definitions);

        const qboPOFieldOptions = selectedDefinitions
            .filter((definition) => definition.legacyIDV2)
            .map((definition) => ({
                Id: definition.legacyIDV2 as string,
                Name: definition.label ?? "",
            }));

        this.setState(
            {
                qboCustomFieldDefinitions: definitions,
                qboPOFieldOptions,
                getCustomFieldDefinitionsActive: false,
            },
            () => {
                this.setState({
                    poFieldComponent: this.poCustomField(),
                });
            }
        );
    };

    getMappableFields = () => {
        const payload: IQBOGetMappableFieldsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetMappableFields, payload);
    };

    onQboGetMappableFields = (data: IOnQBOGetMappableFieldsDTO) => {
        this.setState({ qboMappableFields: data.fields ?? [] });
    };

    saveCustomFieldMappings = (mappings: IQBOCustomFieldMapping[]) => {
        const payload: IQBOSetCustomFieldMappingsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            mappings,
        };

        this.setState({ saveCustomFieldMappingsActive: true });
        this.props.socket.emit(EndpointsEnum.QBOSetCustomFieldMappings, payload);
    };

    onQboSetCustomFieldMappings = (data: IOnQBOSetCustomFieldMappingsDTO) => {
        const notification: INotification = {
            message: "successfully_updated_integrations",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            qboCustomFieldMappings: data.mappings ?? [],
            saveCustomFieldMappingsActive: false,
        });
    };

    getTaxCodes = () => {
        const payload: IQBOGetTaxCodesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetTaxCodes, payload);
    };

    onQboGetTaxCodes = (data: IOnQBOGetTaxCodesDTO) => {
        console.log("onQboGetTaxCodes: ", data);
    };

    getCOGSAccounts = () => {
        const payload: IQBOGetAccountsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            accountType: QBOAccountTypeEnum.COST_OF_GOOD_SOLD,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetAccounts, payload);
    };

    onUpdateSupplierIntegrations = (data: IOnUpdateSupplierIntegrationsDTO) => {
        const notification: INotification = {
            message: "successfully_updated_integrations",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            saveDefaultPriceGroupActive: false,
            saveCustomFieldActive: false,
            saveInventoryAssetAcctActive: false,
            saveCOGSAccountActive: false,
            saveDefaultTaxRateActive: false,
            activeAutoSalesTax: false,
            saveAPAccountActive: false,
            saveCountryActive: false,
        });

        this.endSave();
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "QuickbooksConnect",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState(
            {
                catalogs: data.catalogs,
                catalog_id: this.props.supplierModel.Supplier_Integration.QBO_DefaultPriceGroup?.catalog_id || undefined,
            },
            () => {
                if (!this.state.priceGroups.length && this.state.catalog_id) {
                    this.getPriceGroups();
                }
            }
        );
    };

    getPriceGroups = () => {
        const catalog = this.state.catalogs.find((catalog) => {
            return Number(catalog.id) === Number(this.state.catalog_id);
        });

        if (catalog) {
            const payload: IGetPriceGroupsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid: catalog.guid,
            };

            this.props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
        }
    };

    onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        this.setState({
            priceGroups: data.priceGroups,
            price_group_id: this.props.supplierModel.Supplier_Integration.QBO_DefaultPriceGroup?.id || undefined,
        });
    };

    onLoadUser = (data: IOnLoadUserDTO) => {
        if (data.supplier && data.supplier.Supplier_Integration) {
            if (!data.supplier.Supplier_Integration.has_qbo) {
                this.setState({
                    incomeAccountComponent: null,
                    poFieldComponent: null,
                    termsComponent: null,
                });
            }
        }
    };

    getQboPayload = () => {
        return {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };
    };

    notify = () => {
        this.setState({
            saveIncomeAcctActive: false,
            saveCustomFieldActive: false,
            saveCustomFieldMappingsActive: false,
        });

        // notify is the error/terminal channel for these writes; settle this save's slot too.
        this.endSave();
    };

    startQBConnect = () => {
        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            enable_payments: this.state.enable_payments,
        };

        this.props.socket.emit(EndpointsEnum.QBOOAuthStart, payload);
    };

    disconnectQuickbooks = () => {
        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOOAuthDisconnect, payload);
    };

    onQboOauthStart = (data: IQBOOnOAuthStartDTO) => {
        console.log("onQboOauthStart: ", data);
        // @ts-expect-error
        window.location = data.url;
    };

    onQboOauthDisconnect = (data: IQBOOnOAuthDisconnectDTO) => {
        const payload: ILoadUserDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
        };

        this.props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    onQboGetIncomeAccounts = (data: IOnQBOGetIncomeAccountsDTO) => {
        this.setState(
            {
                qboIncomeAccounts: data.incomeAccounts,
            },
            () => {
                this.setState({
                    incomeAccountComponent: this.getIncomeAccountSelection(),
                });
            }
        );
        // console.log('onQboGetIncomeAccounts', data);
    };

    qboGetAccounts = (accountType: QBOAccountTypeEnum) => {
        const payload: IQBOGetAccountsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            accountType,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetAccounts, payload);
    };

    onQboGetAccounts = (data: IQBOOnGetAccountsDTO) => {
        const state: any = {};

        switch (data.accountType) {
            case QBOAccountTypeEnum.COST_OF_GOOD_SOLD:
                state.qboCOGSAccounts = data.accounts;
                break;
            case QBOAccountTypeEnum.ACCOUNTS_PAYABLE:
                state.qboAPAccounts = data.accounts;
                break;
        }

        this.setState(state);
    };

    onQboGetOtherCurrentAssetAccounts = (data: IQBOOnGetOtherCurrentAssetAccountsDTO) => {
        this.setState({
            qboOtherCurrentAssetAccounts: data.accounts,
        });
    };

    onQboGetCustomSalesFields = (data: IOnQBOGetCustomSalesFieldsDTO) => {
        let qboCustomSalesFields: { Id: string | null; Name: string | undefined }[] = [];

        let qboRawCustomSalesFields: IQBOCustomFieldDTO[] = [];

        if (data.customSalesFields) {
            qboRawCustomSalesFields = data.customSalesFields;

            // console.log("fields", fields);

            qboCustomSalesFields = data.customSalesFields
                .filter((field) => field.Type === "StringType")
                .map((field) => {
                    const IdMatches = field.Name.match(/\d+/);

                    const Id = IdMatches ? IdMatches[0] : null;
                    const Name = field.StringValue;

                    return {
                        Id,
                        Name,
                    };
                });

            // console.log("qboCustomSalesFields", qboCustomSalesFields);
        }

        this.setState(
            {
                qboCustomSalesFields,
                qboRawCustomSalesFields,
                getCustomFieldsActive: false,
            },
            () => {
                this.setState({
                    poFieldComponent: this.poCustomField(),
                });
            }
        );
    };

    onQboGetTerms = (data: IOnQBOGetTermsDTO) => {
        // console.log("onQboGetTerms", data);
        this.setState(
            {
                qboTermOptions: data.termOptions,
                qboTermOptionsLoaded: true,
            },
            () => {
                this.setState({
                    termsComponent: this.getDefaultSalesTerms(),
                });
            }
        );
    };

    saveQboCatalogItemIncomeAcct = () => {
        this.setState(
            {
                saveIncomeAcctActive: true,
            },
            () => {
                const option: IQBOAccountDTO | undefined = this.state.qboIncomeAccounts.find((account: IQBOAccountDTO) => {
                    if (account.Id === this.state.qbo_CatalogItemIncomeAcctId) {
                        return account;
                    }
                });

                if (option) {
                    const payload: IQBOSetCatalogItemIncomeAccountDTO = {
                        userToken: this.props.userModel.token,
                        userGuid: this.props.userModel.guid,
                        supplierGuid: this.props.supplierModel.guid,
                        incomeAccount: option,
                    };

                    this.beginSave();
                    this.props.socket.emit(EndpointsEnum.QBOSetCatalogItemIncomeAccount, payload);
                }
            }
        );
    };

    saveAutoSalesTax = () => {
        this.setState(
            {
                activeAutoSalesTax: true,
            },
            () => {
                const payload: IUpdateSupplierIntegrationsDTO = {
                    userToken: this.props.userModel.token,
                    userGuid: this.props.userModel.guid,
                    supplierGuid: this.props.supplierModel.guid,
                    // @ts-expect-error
                    Supplier_Integration: {
                        qbo_UsingAutoSalesTax: this.state.qbo_UsingAutoSalesTax,
                        qbo_TaxOnShippingAdjustment: this.state.qbo_TaxOnShippingAdjustment,
                    },
                };

                this.beginSave();
                this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
            }
        );
    };

    saveQboInventoryAssetAcct = () => {
        this.setState(
            {
                saveInventoryAssetAcctActive: true,
            },
            () => {
                const option: IQBOAccountDTO | undefined = this.state.qboOtherCurrentAssetAccounts.find((account: IQBOAccountDTO) => {
                    if (account.Id === this.state.qbo_InventoryAssetAccountId) {
                        return account;
                    }
                });

                if (option) {
                    const payload: IUpdateSupplierIntegrationsDTO = {
                        userToken: this.props.userModel.token,
                        userGuid: this.props.userModel.guid,
                        supplierGuid: this.props.supplierModel.guid,
                        // @ts-expect-error
                        Supplier_Integration: {
                            qbo_InventoryAssetAccountId: option.Id,
                            qbo_InventoryAssetAccountName: option.Name,
                        },
                    };

                    this.beginSave();
                    this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
                }
            }
        );
    };

    saveQBOCOGSAccount = () => {
        this.setState(
            {
                saveCOGSAccountActive: true,
            },
            () => {
                const option: IQBOAccountDTO | undefined = this.state.qboCOGSAccounts.find((account: IQBOAccountDTO) => {
                    if (account.Id === this.state.qbo_COGSAccountId) {
                        return account;
                    }
                });

                if (option) {
                    const payload: IUpdateSupplierIntegrationsDTO = {
                        userToken: this.props.userModel.token,
                        userGuid: this.props.userModel.guid,
                        supplierGuid: this.props.supplierModel.guid,
                        // @ts-expect-error
                        Supplier_Integration: {
                            qbo_COGSAccountId: option.Id,
                            qbo_COGSAccountName: option.Name,
                        },
                    };

                    this.beginSave();
                    this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
                }
            }
        );
    };

    saveQBOAPAccount = () => {
        this.setState(
            {
                saveAPAccountActive: true,
            },
            () => {
                const option: IQBOAccountDTO | undefined = this.state.qboAPAccounts.find((account: IQBOAccountDTO) => {
                    if (account.Id === this.state.qbo_po_default_ap_account?.Id) {
                        return account;
                    }
                });

                if (option) {
                    const payload: IUpdateSupplierIntegrationsDTO = {
                        userToken: this.props.userModel.token,
                        userGuid: this.props.userModel.guid,
                        supplierGuid: this.props.supplierModel.guid,
                        // @ts-expect-error
                        Supplier_Integration: {
                            qbo_po_default_ap_account: option,
                        },
                    };

                    this.beginSave();
                    this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
                }
            }
        );
    };

    saveCustomSalesField = () => {
        this.setState(
            {
                saveCustomFieldActive: true,
            },
            () => {
                const poFieldOptions = this.isEnhancedCustomFields() ? this.state.qboPOFieldOptions : this.state.qboCustomSalesFields;

                const option = poFieldOptions.find((customField) => customField.Id === this.state.qbo_POCustomFieldId);

                const payload: IQBOSetDefaultPOFieldDTO = {
                    userToken: this.props.userModel.token,
                    userGuid: this.props.userModel.guid,
                    supplierGuid: this.props.supplierModel.guid,
                    // Emit empty strings when nothing is selected so the API clears (nulls out) the PO field.
                    customField: option ? { Id: option.Id ?? "", Name: option.Name ?? "" } : { Id: "", Name: "" },
                };

                this.beginSave();
                this.props.socket.emit(EndpointsEnum.QBOSetDefaultPOField, payload);
            }
        );
    };

    toggleQBOPayments = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_qbo_payments: !this.props.supplierModel.Supplier_Integration.has_qbo_payments,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    saveDefaultPriceGroup = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                qbo_DefaultPriceGroup: this.state.price_group_id,
            },
        };

        this.beginSave();
        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        this.setState({
            saveDefaultPriceGroupActive: true,
        });
    };

    saveQboTerm = () => {
        this.setState(
            {
                saveTermFieldActive: true,
            },
            () => {
                const option = _.find(this.state.qboTermOptions, (termOption) => {
                    if (termOption.Id === this.state.qbo_DefaultTermId) {
                        return termOption;
                    }
                });

                const payload: IQBOSetDefaultSalesTermDTO = {
                    userToken: this.props.userModel.token,
                    userGuid: this.props.userModel.guid,
                    supplierGuid: this.props.supplierModel.guid,
                    salesTerm: option,
                };

                this.beginSave();
                this.props.socket.emit(EndpointsEnum.QBOSetDefaultSalesTerm, payload);
            }
        );
    };

    loadUser = () => {
        const payload: ILoadUserDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
        };

        this.props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    onQboSetCatalogItemIncomeAccount = (data: IOnQBOSetCatalogItemIncomeAccountDTO) => {
        const notification: INotification = {
            title: "saved_catalog_item_income_account",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                saveIncomeAcctActive: false,
            },
            () => {
                this.endSave();
                this.loadUser();
            }
        );
    };

    onQboSetDefaultSalesTerm = (data: IOnQBOSetDefaultSalesTermDTO) => {
        const notification: INotification = {
            title: "saved_default_sales_term",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                saveTermFieldActive: false,
            },
            () => {
                this.endSave();
                this.loadUser();
            }
        );
    };

    onQboSetDefaultPOField = (data: IOnQBOSetDefaultPOFieldDTO) => {
        const notification: INotification = {
            title: "saved_po_custom_field",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                saveCustomFieldActive: false,
            },
            () => {
                this.endSave();
                this.loadUser();
            }
        );
    };

    saveQboCountry = () => {
        this.setState(
            {
                saveCountryActive: true,
            },
            () => {
                const payload: IUpdateSupplierIntegrationsDTO = {
                    userToken: this.props.userModel.token,
                    userGuid: this.props.userModel.guid,
                    supplierGuid: this.props.supplierModel.guid,
                    // @ts-expect-error
                    Supplier_Integration: {
                        qbo_Country: this.state.qbo_Country,
                    },
                };

                this.beginSave();
                this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
            }
        );
    };

    getCountryField = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo) {
            return null;
        }

        return (
            <div className="col-12">
                <div>
                    <div className={"col-12"}>
                        <OwLabel className={"me-2"} title={"country"} />
                    </div>
                    <div className={"col-12 mb-2"}>
                        <OwSelectOption
                            options={this.qboCountryOptions}
                            valueProp={"value"}
                            titleProp={"title"}
                            fn={this.handleChange}
                            selectedOption={this.state}
                            selectedOptionProp={"qbo_Country"}
                            name={"qbo_Country"}
                        />
                    </div>
                    <div className={"col-12"}>
                        <OwButton disableOnActive={true} active={this.state.saveCountryActive} fn={this.saveQboCountry} title={"save"} />
                    </div>
                </div>
            </div>
        );
    };

    getIncomeAccountSelection = () => {
        if (!this.state.qboIncomeAccounts?.length) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_income_account_options"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"default_catalog_item_income_account"} />

                            <WhatsThis subject={"help_text_qbo_default_catalog_item_income_account"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            {this.state.qboIncomeAccounts ? (
                                <OwSelectOption
                                    options={this.state.qboIncomeAccounts}
                                    valueProp={"Id"}
                                    titleProp={"Name"}
                                    fn={this.handleChange}
                                    selectedOption={this.state}
                                    selectedOptionProp={"qbo_CatalogItemIncomeAcctId"}
                                    name={"qbo_CatalogItemIncomeAcctId"}
                                    showBlankFirst={true}
                                />
                            ) : null}
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disabled={this.state.saveIncomeAcctActive}
                                active={this.state.saveIncomeAcctActive}
                                fn={this.saveQboCatalogItemIncomeAcct}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    getInventoryAssetAccountField = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo) {
            return null;
        }

        if (!this.state.qboOtherCurrentAssetAccounts?.length) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_default_inventory_asset_account_options"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"default_inventory_asset_account"} />

                            <WhatsThis subject={"help_text_qbo_default_inventory_asset_account"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            {this.state.qboOtherCurrentAssetAccounts ? (
                                <OwSelectOption
                                    options={this.state.qboOtherCurrentAssetAccounts}
                                    valueProp={"Id"}
                                    titleProp={"Name"}
                                    fn={this.handleChange}
                                    selectedOption={this.state}
                                    selectedOptionProp={"qbo_InventoryAssetAccountId"}
                                    name={"qbo_InventoryAssetAccountId"}
                                    showBlankFirst={true}
                                />
                            ) : null}
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disableOnActive={true}
                                active={this.state.saveInventoryAssetAcctActive}
                                fn={this.saveQboInventoryAssetAcct}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    getCOGSAccountField = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo) {
            return null;
        }

        if (!this.state.qboCOGSAccounts?.length) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_cogs_account_options"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"default_cogs_account"} />

                            <WhatsThis subject={"help_text_qbo_default_cogs_account"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            {this.state.qboCOGSAccounts ? (
                                <OwSelectOption
                                    options={this.state.qboCOGSAccounts}
                                    valueProp={"Id"}
                                    titleProp={"Name"}
                                    fn={this.handleChange}
                                    selectedOption={this.state}
                                    selectedOptionProp={"qbo_COGSAccountId"}
                                    name={"qbo_COGSAccountId"}
                                    showBlankFirst={true}
                                />
                            ) : null}
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disableOnActive={true}
                                active={this.state.saveCOGSAccountActive}
                                fn={this.saveQBOCOGSAccount}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    getAPAccountField = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo) {
            return null;
        }

        if (!this.state.qboAPAccounts?.length) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_ap_account_options"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"default_ap_account"} />

                            <WhatsThis subject={"help_text_qbo_default_ap_account"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            {this.state.qboAPAccounts ? (
                                <OwSelectOption
                                    options={this.state.qboAPAccounts}
                                    valueProp={"Id"}
                                    titleProp={"Name"}
                                    fn={this.handleApChange}
                                    selectedOption={this.state.qbo_po_default_ap_account}
                                    selectedOptionProp={"Id"}
                                    emitObject={true}
                                    name={"qbo_po_default_ap_account"}
                                    showBlankFirst={true}
                                />
                            ) : null}
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disableOnActive={true}
                                active={this.state.saveAPAccountActive}
                                fn={this.saveQBOAPAccount}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    getAutoSalesTaxField = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo) {
            return null;
        }

        return (
            <div className="col-12 mb-5">
                <div>
                    <div className={"col-12 mb-2"}>
                        <OwToggle
                            fn={this.handleChange}
                            name={"qbo_UsingAutoSalesTax"}
                            label={"using_auto_sales_tax"}
                            active={!!this.props.supplierModel.Supplier_Integration.qbo_UsingAutoSalesTax}
                            labelOnRight={true}
                        />
                    </div>
                    <div className={"col-12"}>
                        <WhatsThis subject={"help_text_qbo_using_auto_sales_tax"} />
                    </div>
                    {this.props.supplierModel.sales_tax_config?.shippingTaxable ? (
                        <div className={"d-flex align-items-center mb-2"}>
                            <OwToggle
                                fn={this.handleChange}
                                name={"qbo_TaxOnShippingAdjustment"}
                                label={"tax_on_shipping_adjustment"}
                                active={!!this.props.supplierModel.Supplier_Integration.qbo_TaxOnShippingAdjustment}
                                labelOnRight={true}
                            />
                            <OwIconTooltip
                                iconClassName={"ms-2 fas fa-info-circle"}
                                tooltipContent={"tax_on_shipping_adjustment_tooltip"}
                                translateContent={true}
                            />
                        </div>
                    ) : null}
                    <div className={"col-12"}>
                        <OwButton disableOnActive={true} active={this.state.activeAutoSalesTax} fn={this.saveAutoSalesTax} title={"save"} />
                    </div>
                    {this.state.qbo_UsingAutoSalesTax ? null : (
                        <div className="col-12">
                            {this.props.supplierModel.tax_rate ? (
                                <div>
                                    <OwLabel title={"no_auto_sales_tax_but_tax_rate_set"} postText={":"} />{" "}
                                    {this.props.supplierModel.tax_rate}%
                                </div>
                            ) : null}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    getDefaultSalesTerms = () => {
        if (!this.state.qboTermOptions?.length && !this.state.qboTermOptionsLoaded) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_sales_term_options"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"default_sale_terms"} />

                            <WhatsThis subject={"help_text_qbo_default_sale_terms"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            <OwSelectOption
                                options={this.state.qboTermOptions}
                                valueProp={"Id"}
                                titleProp={"Name"}
                                fn={this.handleChange}
                                selectedOption={this.state}
                                selectedOptionProp={"qbo_DefaultTermId"}
                                name={"qbo_DefaultTermId"}
                                showBlankFirst={true}
                            />
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disabled={this.state.saveTermFieldActive}
                                active={this.state.saveTermFieldActive}
                                fn={this.saveQboTerm}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    poCustomField = () => {
        const isEnhanced = this.isEnhancedCustomFields();
        const loadingPoOptions = isEnhanced ? this.state.getCustomFieldDefinitionsActive : this.state.getCustomFieldsActive;
        const poFieldOptions = isEnhanced ? this.state.qboPOFieldOptions : this.state.qboCustomSalesFields;

        if (loadingPoOptions) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_custom_sales_fields"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"po_invoice_custom_field"} />

                            <WhatsThis subject={"help_text_qbo_po_invoice_custom_field"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            <OwSelectOption
                                options={poFieldOptions}
                                valueProp={"Id"}
                                titleProp={"Name"}
                                fn={this.handleChange}
                                selectedOption={this.state}
                                selectedOptionProp={"qbo_POCustomFieldId"}
                                name={"qbo_POCustomFieldId"}
                                showBlankFirst={true}
                            />
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disabled={this.state.saveCustomFieldActive}
                                active={this.state.saveCustomFieldActive}
                                fn={this.saveCustomSalesField}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    toggleQboHowTo = (field: string) => {
        // @ts-expect-error
        const selectedField = this.state[field];

        const state: any = {
            // @ts-expect-error
            [field]: !selectedField,
        };

        this.setState(state);
    };

    changeSalesRepField = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const salesRepField = this.state.qboCustomSalesFields.find((field) => {
            return field.Id === value;
        });

        if (salesRepField && salesRepField.Id && salesRepField.Name) {
            const state: any = {
                qbo_SalesRepCustomFieldName: salesRepField.Name,
                qbo_SalesRepCustomFieldId: salesRepField.Id,
            };

            this.applyDirty(state, "qbo_SalesRepCustomFieldId");

            this.setState(state);
        }
    };

    changeRepGroupField = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const repGroupField = this.state.qboCustomSalesFields.find((field) => {
            return field.Id === value;
        });

        if (repGroupField) {
            const state: any = {
                qbo_RepGroupCustomFieldName: repGroupField?.Name,
                qbo_RepGroupCustomFieldId: repGroupField?.Id,
            };

            this.applyDirty(state, "qbo_RepGroupCustomFieldId");

            this.setState(state);
        }
    };

    saveRepGroupField = () => {
        const repGroupField = this.state.qboCustomSalesFields.find((field) => {
            return field.Id === this.state.qbo_RepGroupCustomFieldId;
        });

        if (repGroupField && repGroupField.Id && repGroupField.Name) {
            const payload: IUpdateSupplierIntegrationsDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                // @ts-expect-error
                Supplier_Integration: {
                    qbo_RepGroupCustomFieldName: repGroupField.Name,
                    qbo_RepGroupCustomFieldId: this.state.qbo_RepGroupCustomFieldId,
                },
            };

            this.beginSave();
            this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

            this.setState({
                saveCustomFieldActive: true,
            });
        }
    };

    getCustomSalesFieldByName = (Name: string) => {
        return this.state.qboRawCustomSalesFields.find((field) => field.StringValue === Name);
    };

    saveCustomFields = () => {
        const customFieldOne = this.state.qbo_CustomFieldValueOne
            ? this.getCustomSalesFieldByName(this.state.qbo_CustomFieldValueOne)
            : null;
        const customFieldTwo = this.state.qbo_CustomFieldValueTwo
            ? this.getCustomSalesFieldByName(this.state.qbo_CustomFieldValueTwo)
            : null;
        const customFieldThree = this.state.qbo_CustomFieldValueThree
            ? this.getCustomSalesFieldByName(this.state.qbo_CustomFieldValueThree)
            : null;

        const payload: IUpdateSupplierIntegrationsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                qbo_CustomFieldOne: customFieldOne,
                qbo_CustomFieldTwo: customFieldTwo,
                qbo_CustomFieldThree: customFieldThree,
                qbo_ow_num_as_invoice_ref: this.state.qbo_ow_num_as_invoice_ref,
                qbo_AllowAchPayments: this.state.qbo_AllowAchPayments,
                qbo_use_ow_quote_num_for_estimate: this.state.qbo_use_ow_quote_num_for_estimate,
                qbo_hide_quote_ow_btns: this.state.qbo_hide_quote_ow_btns,
                qbo_quote_for_est_name: this.state.qbo_quote_for_est_name,
                qbo_estimate_from_order: this.state.qbo_estimate_from_order,
                qbo_est_invoice_auto_ship: this.state.qbo_est_invoice_auto_ship,
                qbo_pull_assign_rep_user: this.state.qbo_pull_assign_rep_user,
                qbo_pull_rep_user_target: this.state.qbo_pull_rep_user_target,
                qbo_invoice_memo: this.state.qbo_invoice_memo,
                qbo_customer_name_field: this.state.qbo_customer_name_field,
                qbo_grouped_invoices: this.state.qbo_grouped_invoices,
                // qbo_grouped_invoices_by_day: this.state.qbo_grouped_invoices_by_day,
                qbo_grouped_invoice_type: this.state.qbo_grouped_invoice_type,
                qbo_invoice_default_date: this.state.qbo_invoice_default_date,
                qbo_invoice_default_ship_date: this.state.qbo_invoice_default_ship_date,
                qbo_GlobalTaxCalculationEnum: this.state.qbo_GlobalTaxCalculationEnum,
                qbo_DefaultShipMethodRefValue: this.state.qbo_DefaultShipMethodRefValue,
            },
        };

        payload.Supplier_Integration.qbo_shipping_catalog_item_id = this.state.selectedShippingItem
            ? this.state.selectedShippingItem.id
            : null;

        this.beginSave();
        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        this.setState({
            saveCustomFieldActive: true,
        });
    };

    saveAutoPullOptions = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                qbo_auto_pull_products: this.state.qbo_auto_pull_products,
                qbo_auto_pull_customers: this.state.qbo_auto_pull_customers,
                qbo_auto_pull_categories: this.state.qbo_auto_pull_categories,
                qbo_update_accounts_on_save: this.state.qbo_update_accounts_on_save,
                qbo_using_classes: this.state.qbo_using_classes,
                qbo_push_inventory_updates: this.state.qbo_push_inventory_updates,
                qbo_skip_inventory_updates: this.state.qbo_skip_inventory_updates,
                qbo_skip_category_assignment: this.state.qbo_skip_category_assignment,
                qbo_skip_category_sync: this.state.qbo_skip_category_sync,
            },
        };

        this.beginSave();
        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        this.setState({
            saveCustomFieldActive: true,
        });
    };

    saveSalesRepField = () => {
        const salesRepField = this.state.qboCustomSalesFields.find((field) => {
            return field.Id === this.state.qbo_SalesRepCustomFieldId;
        });

        if (salesRepField) {
            const payload: IUpdateSupplierIntegrationsDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                // @ts-expect-error
                Supplier_Integration: {
                    qbo_SalesRepCustomFieldName: salesRepField.Name,
                    qbo_SalesRepCustomFieldId: this.state.qbo_SalesRepCustomFieldId,
                },
            };

            this.beginSave();
            this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

            this.setState({
                saveCustomFieldActive: true,
            });
        }
    };

    getRepGroupField = () => {
        if (!this.props.supplierModel.has_rep_groups) {
            return null;
        }

        return (
            <div className={"col-12"}>
                <div className={"col-12"}>
                    <div>
                        <OwLabel className={"me-2"} title={"rep_group_custom_field"} />

                        <WhatsThis subject={"help_text_rep_group_custom_field"} />
                    </div>
                    <div className={"mb-2"}>
                        <OwSelectOption
                            options={this.state.qboCustomSalesFields}
                            valueProp={"Id"}
                            titleProp={"Name"}
                            fn={this.changeRepGroupField}
                            selectedOption={this.state}
                            selectedOptionProp={"qbo_RepGroupCustomFieldId"}
                            name={"qbo_RepGroupCustomFieldName"}
                            showBlankFirst={true}
                        />
                    </div>
                    <div className={""}>
                        <OwButton
                            disabled={this.state.saveCustomFieldActive}
                            active={this.state.saveCustomFieldActive}
                            fn={this.saveRepGroupField}
                            title={"save"}
                        />
                    </div>
                </div>
            </div>
        );
    };

    getSalesRepField = () => {
        if (!this.props.supplierModel.has_rep_groups) {
            return null;
        }

        return (
            <div className={"col-12"}>
                <div className={"col-12"}>
                    <div>
                        <OwLabel className={"me-2"} title={"sales_rep_custom_field"} />

                        <WhatsThis subject={"help_text_sales_rep_custom_field"} />
                    </div>
                    <div className={"mb-2"}>
                        <OwSelectOption
                            options={this.state.qboCustomSalesFields}
                            valueProp={"Id"}
                            titleProp={"Name"}
                            fn={this.changeSalesRepField}
                            selectedOption={this.state}
                            selectedOptionProp={"qbo_SalesRepCustomFieldId"}
                            name={"qbo_SalesRepCustomFieldName"}
                            showBlankFirst={true}
                        />
                    </div>
                    <div className={""}>
                        <OwButton
                            disabled={this.state.saveCustomFieldActive}
                            active={this.state.saveCustomFieldActive}
                            fn={this.saveSalesRepField}
                            title={"save"}
                        />
                    </div>
                </div>
            </div>
        );
    };

    handleApChange = (obj: any) => {
        const state: any = { qbo_po_default_ap_account: obj };
        this.applyDirty(state, "qbo_po_default_ap_account");
        this.setState(state);
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.applyDirty(state, name);

        this.setState(state, () => {
            if (name === "catalog_id") {
                this.getPriceGroups();
            }
        });
    };

    // Flag the group + save-target for a changed field onto a pending setState payload (so it's a single render).
    applyDirty = (state: any, name: string) => {
        const group = QBO_FIELD_GROUP[name];
        const target = QBO_FIELD_TARGET[name];

        if (group && !this.state.qboDirtyGroups.includes(group)) {
            state.qboDirtyGroups = [...this.state.qboDirtyGroups, group];
        }

        if (target && !this.state.qboDirtyTargets.includes(target)) {
            state.qboDirtyTargets = [...this.state.qboDirtyTargets, target];
        }
    };

    toggleGroup = (groupId: string) => {
        this.setState((s) => ({
            qboOpenGroups: { ...s.qboOpenGroups, [groupId]: !s.qboOpenGroups[groupId] },
        }));
    };

    toggleHelp = (fieldKey: string) => {
        this.setState((s) => ({
            qboOpenHelp: { ...s.qboOpenHelp, [fieldKey]: !s.qboOpenHelp[fieldKey] },
        }));
    };

    setAllGroups = (open: boolean) => {
        const qboOpenGroups: { [groupId: string]: boolean } = {};
        QBO_GROUPS.forEach((group) => (qboOpenGroups[group.id] = open));
        this.setState({ qboOpenGroups });
    };

    // Number of panel saves currently in flight. Each fired write increments it at its emit site
    // (beginSave); each write's own success/notify handler decrements it (endSave). The panel only
    // settles — spinner off, dirty cleared — when this returns to zero, never on the first response.
    qboSavePending = 0;

    beginSave = () => {
        this.qboSavePending += 1;

        if (!this.state.qboSavingAll) {
            this.setState({ qboSavingAll: true });
        }
    };

    endSave = () => {
        if (this.qboSavePending === 0) {
            return;
        }

        this.qboSavePending -= 1;

        if (this.qboSavePending === 0) {
            this.setState({ qboSavingAll: false, qboDirtyGroups: [], qboDirtyTargets: [] });
        }
    };

    // The single panel Save: fire only the endpoints for groups that actually changed. Each fired write
    // tracks itself via beginSave/endSave, so the dirty state clears only once every write has come back.
    saveAll = () => {
        const fnByTarget: { [key in QboSaveTarget]: () => void } = {
            country: this.saveQboCountry,
            terms: this.saveQboTerm,
            customFields: this.saveCustomFields,
            autoSalesTax: this.saveAutoSalesTax,
            incomeAccount: this.saveQboCatalogItemIncomeAcct,
            inventoryAsset: this.saveQboInventoryAssetAcct,
            cogs: this.saveQBOCOGSAccount,
            apAccount: this.saveQBOAPAccount,
            autoPull: this.saveAutoPullOptions,
            priceGroup: this.saveDefaultPriceGroup,
            salesRep: this.saveSalesRepField,
            repGroup: this.saveRepGroupField,
            poField: this.saveCustomSalesField,
        };

        const targets = this.state.qboDirtyTargets;

        if (!targets.length) {
            return;
        }

        targets.forEach((target) => {
            const fn = fnByTarget[target as QboSaveTarget];
            if (fn) {
                fn();
            }
        });
    };

    clearShippingItem = () => {
        const state: any = { selectedShippingItem: null };
        this.applyDirty(state, "selectedShippingItem");
        this.setState(state);
    };

    handleShippingItemSelect = (item: ICatalog_Item) => {
        const state: any = { selectedShippingItem: item };
        this.applyDirty(state, "selectedShippingItem");
        this.setState(state);
    };

    shippingItemLookup = (name: string) => {
        if (this.state.catalog_id && this.state.catalogs) {
            const catalogModel = this.state.catalogs.find((catalog) => {
                return catalog.id === this.state.catalog_id;
            });

            if (catalogModel) {
                const payload: ITypeaheadCatalogItemDTO = {
                    userToken: this.props.userModel.token,
                    userGuid: this.props.userModel.guid,
                    supplierGuid: this.props.supplierModel.guid,
                    name,
                    catalogGuid: catalogModel.guid,
                    options: {
                        searchName: true,
                        searchDescription: true,
                        searchSku: true,
                        searchUpc: true,
                    },
                };

                this.props.socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
            }
        }
    };

    onShippingItemLookup = (data: IOnTypeaheadCatalogItemDTO) => {
        this.setState({
            foundShippingItems: data.catalog_items,
        });
    };

    forceCustomFieldActive = (index: 1 | 2 | 3) => {
        const payload: IQBOForceCustomFieldActiveDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            customFieldNumber: index,
        };

        this.props.socket.emit(EndpointsEnum.QBOForceCustomFieldActive, payload);
    };

    onForceCustomFieldActive = (data: IQBOForceCustomFieldActiveDTO) => {
        const notification: INotification = {
            message: "successfully_forced_custom_field_active",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);
    };

    getPreferences = () => {
        const payload: IQBOGetPreferencesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetPreferences, payload);
    };

    onGetPreferences = (data: IQBOOnGetPreferencesDTO) => {
        console.log(data);
    };

    // ---------------------------------------------------------------------
    // Redesign: nested-accordion config groups (Status treatment, compact).
    // ---------------------------------------------------------------------

    qboCustomerNameFieldOptions = [
        { value: "DisplayName", title: "Display Name" },
        { value: "CompanyName", title: "Company Name" },
    ];

    // Count "set" inputs for a group summary chip (blank / "Not set" don't count).
    qboSetCount = (values: any[]) => values.filter((v) => v !== undefined && v !== null && v !== "" && v !== "Not set").length;

    qboSummary = (inputValues: any[], toggleValues: boolean[]) => {
        const parts: React.ReactNode[] = [];

        if (inputValues.length) {
            parts.push(
                <span key="set">
                    {this.qboSetCount(inputValues)}/{inputValues.length} <OwLabel title={"set"} noBottomMargin={true} />
                </span>
            );
        }

        if (toggleValues.length) {
            parts.push(
                <span key="on">
                    {toggleValues.filter(Boolean).length} <OwLabel title={"on"} noBottomMargin={true} />
                </span>
            );
        }

        return (
            <>
                {parts.map((part, index) => (
                    <React.Fragment key={index}>
                        {index > 0 ? <span>{" · "}</span> : null}
                        {part}
                    </React.Fragment>
                ))}
            </>
        );
    };

    qboLoading = (labelKey: string) => (
        <div className={"qbo-field-loading"}>
            <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={labelKey} noBottomMargin={true} />
        </div>
    );

    // Inline info button (sits at the end of a label, on the same line).
    qboHelpButton = (fieldKey: string) => (
        <button
            type={"button"}
            className={"qbo-help-toggle"}
            onClick={() => this.toggleHelp(fieldKey)}
            aria-label={"whats_this"}
            title={"whats_this"}>
            <i className={"fas fa-info-circle"} />
        </button>
    );

    // The expandable help text, rendered below the control when its info button is toggled on.
    qboHelpText = (fieldKey: string, subject: string) =>
        this.state.qboOpenHelp[fieldKey] ? (
            <div className={"qbo-help-text"}>
                <OwLabel title={subject} preserveNewlines={true} noBottomMargin={true} />
            </div>
        ) : null;

    qboField = (
        labelKey: string,
        control: React.ReactNode,
        opts?: { help?: string; whatsThis?: string; key?: string; htmlFor?: string }
    ) => {
        const fieldKey = opts?.key || labelKey;

        return (
            <div className={"qbo-field"} key={fieldKey}>
                <div className={"qbo-field-label"}>
                    <OwLabel title={labelKey} for={opts?.htmlFor} noBottomMargin={true} />
                    {opts?.whatsThis ? this.qboHelpButton(fieldKey) : null}
                </div>
                {control}
                {opts?.whatsThis ? this.qboHelpText(fieldKey, opts.whatsThis) : null}
                {opts?.help ? (
                    <div className={"qbo-field-help"}>
                        <OwLabel title={opts.help} noBottomMargin={true} />
                    </div>
                ) : null}
            </div>
        );
    };

    qboToggleRow = (labelKey: string, name: string, active: boolean, opts?: { help?: string; whatsThis?: string }) => (
        <div className={"qbo-toggle-row"} key={name}>
            <OwToggle fn={this.handleChange} name={name} label={""} active={active} />
            <div className={"qbo-toggle-text"}>
                <div className={"qbo-toggle-label"}>
                    <OwLabel title={labelKey} noBottomMargin={true} />
                    {opts?.whatsThis ? this.qboHelpButton(name) : null}
                </div>
                {opts?.whatsThis ? this.qboHelpText(name, opts.whatsThis) : null}
                {opts?.help ? (
                    <div className={"qbo-field-help"}>
                        <OwLabel title={opts.help} noBottomMargin={true} />
                    </div>
                ) : null}
            </div>
        </div>
    );

    renderConfigGroup = (groupId: string, summary: React.ReactNode, body: React.ReactNode) => {
        const meta = QBO_GROUPS.find((group) => group.id === groupId)!;
        const open = !!this.state.qboOpenGroups[groupId];
        const dirty = this.state.qboDirtyGroups.includes(groupId);

        return (
            <div className={"qbo-group " + (open ? "is-open" : "")} key={groupId}>
                <button type={"button"} className={"qbo-group-header"} onClick={() => this.toggleGroup(groupId)}>
                    <span className={"qbo-icon-tile " + (open ? "active" : "")}>
                        <i className={"fa-solid " + meta.icon} />
                    </span>
                    <span className={"qbo-group-heading"}>
                        <span className={"qbo-group-name"}>
                            <OwLabel title={meta.label} isBold={true} noBottomMargin={true} />
                            {dirty ? <span className={"qbo-dirty-dot"} title={"unsaved_changes"} /> : null}
                        </span>
                        <span className={"qbo-group-desc"}>
                            <OwLabel title={meta.desc} noBottomMargin={true} />
                        </span>
                    </span>
                    <span className={"qbo-group-summary"}>{summary}</span>
                    <i className={"qbo-group-chevron fa-solid fa-chevron-down"} />
                </button>
                {open ? <div className={"qbo-group-body"}>{body}</div> : null}
            </div>
        );
    };

    renderConnectionDetails = () => {
        const supplierIntegrations: any = this.props.supplierModel.Supplier_Integration || {};

        return (
            <div className={"qbo-connection"}>
                <div className={"qbo-capabilities"}>
                    <OwLabel
                        title={"has_qbo_payments"}
                        className={supplierIntegrations.has_qbo_payments ? "text-success" : "text-danger"}
                        leftIconClass={supplierIntegrations.has_qbo_payments ? "fas fa-check" : "fas fa-times"}
                        noBottomMargin={true}
                    />
                    <OwLabel
                        title={"enhanced_custom_fields"}
                        className={supplierIntegrations.qbo_useEnhancedCustomFields ? "text-success" : "text-danger"}
                        leftIconClass={supplierIntegrations.qbo_useEnhancedCustomFields ? "fas fa-check" : "fas fa-times"}
                        noBottomMargin={true}
                    />
                </div>
                <OwButton
                    className={"btn-danger btn-sm"}
                    fn={this.disconnectQuickbooks}
                    leftIconClass={"fas fa-unlink"}
                    title={"business.disconnect_quickbooks"}
                />
            </div>
        );
    };

    renderConfigToolbar = () => {
        const dirty = this.state.qboDirtyGroups.length > 0;

        return (
            <div className={"qbo-subtoolbar"}>
                <span className={"qbo-subtoolbar-title"}>
                    <OwLabel title={"configure"} isBold={true} noBottomMargin={true} />
                </span>
                {dirty ? (
                    <span className={"qbo-status qbo-status-dirty"}>
                        <span className={"qbo-status-dot"} />
                        <OwLabel title={"unsaved_changes"} noBottomMargin={true} />
                    </span>
                ) : (
                    <span className={"qbo-status qbo-status-saved"}>
                        <i className={"fas fa-circle-check me-1"} />
                        <OwLabel title={"all_changes_saved"} noBottomMargin={true} />
                    </span>
                )}
                <span className={"qbo-subtoolbar-spacer"} />
                <OwButton
                    className={"btn-outline-secondary"}
                    leftIconClass={"fas fa-chevron-up"}
                    title={"collapse_all"}
                    fn={() => this.setAllGroups(false)}
                    disableDblClickPrevention={true}
                    disableWidthOnClick={true}
                />
                <OwButton
                    className={"btn-outline-secondary"}
                    leftIconClass={"fas fa-chevron-down"}
                    title={"expand_all"}
                    fn={() => this.setAllGroups(true)}
                    disableDblClickPrevention={true}
                    disableWidthOnClick={true}
                />
                <OwButton
                    className={"btn-primary"}
                    leftIconClass={"fas fa-floppy-disk"}
                    title={"save"}
                    fn={this.saveAll}
                    active={this.state.qboSavingAll}
                    disableOnActive={true}
                    disabled={!dirty}
                    disableWidthOnClick={true}
                />
            </div>
        );
    };

    renderSetupGroup = () => {
        const summary = this.qboSummary(
            [this.state.qbo_Country, this.state.qbo_GlobalTaxCalculationEnum, this.state.catalog_id, this.state.price_group_id],
            []
        );

        const body = (
            <>
                <div className={"qbo-field-grid"}>
                    {this.qboField(
                        "country",
                        <OwSelectOption
                            options={this.qboCountryOptions}
                            valueProp={"value"}
                            titleProp={"title"}
                            fn={this.handleChange}
                            selectedOption={this.state}
                            selectedOptionProp={"qbo_Country"}
                            name={"qbo_Country"}
                            showBlankFirst={false}
                        />,
                        { key: "qbo_Country" }
                    )}
                    {this.qboField(
                        "global_tax_calculation",
                        <OwSelectOption
                            options={this.qboGlobalTaxCalcOptions}
                            valueProp={"value"}
                            titleProp={"title"}
                            translateTitle={true}
                            fn={this.handleChange}
                            selectedOption={this.state}
                            selectedOptionProp={"qbo_GlobalTaxCalculationEnum"}
                            name={"qbo_GlobalTaxCalculationEnum"}
                            showBlankFirst={true}
                        />,
                        {
                            key: "qbo_GlobalTaxCalculationEnum",
                            help: "for_non_us_customers",
                            whatsThis: "help_text_qbo_global_tax_calculation",
                        }
                    )}
                    {this.qboField(
                        "catalogs",
                        <OwSelectOption
                            titleProp={"name"}
                            valueProp={"id"}
                            options={this.state.catalogs}
                            fn={this.handleChange}
                            name={"catalog_id"}
                            selectedOption={this.state}
                            selectedOptionProp={"catalog_id"}
                            emitOnLoad={true}
                            emitTarget={true}
                            showBlankFirst={true}
                        />,
                        { key: "catalog_id", whatsThis: "help_text_qbo_default_price_group" }
                    )}
                    {this.qboField(
                        "price_groups",
                        <OwSelectOption
                            titleProp={"value"}
                            valueProp={"id"}
                            options={this.state.priceGroups}
                            fn={this.handleChange}
                            name={"price_group_id"}
                            selectedOption={this.state}
                            selectedOptionProp={"price_group_id"}
                            emitTarget={true}
                            emitOnLoad={true}
                            showBlankFirst={true}
                        />,
                        { key: "price_group_id" }
                    )}
                </div>
            </>
        );

        return this.renderConfigGroup("setup", summary, body);
    };

    renderItemsGroup = () => {
        const summary = this.qboSummary(
            [
                this.state.qbo_CatalogItemIncomeAcctId,
                this.state.qbo_InventoryAssetAccountId,
                this.state.qbo_COGSAccountId,
                this.state.qbo_po_default_ap_account?.Id,
            ],
            [
                !!this.state.qbo_auto_pull_products,
                !!this.state.qbo_auto_pull_categories,
                !!this.state.qbo_push_inventory_updates,
                !!this.state.qbo_skip_inventory_updates,
                !!this.state.qbo_skip_category_assignment,
                !!this.state.qbo_skip_category_sync,
            ]
        );

        const body = (
            <>
                <div className={"qbo-field-grid"}>
                    {this.qboField(
                        "default_catalog_item_income_account",
                        this.state.qboIncomeAccounts?.length ? (
                            <OwSelectOption
                                options={this.state.qboIncomeAccounts}
                                valueProp={"Id"}
                                titleProp={"Name"}
                                fn={this.handleChange}
                                selectedOption={this.state}
                                selectedOptionProp={"qbo_CatalogItemIncomeAcctId"}
                                name={"qbo_CatalogItemIncomeAcctId"}
                                showBlankFirst={true}
                            />
                        ) : (
                            this.qboLoading("loading_income_account_options")
                        ),
                        { key: "qbo_CatalogItemIncomeAcctId", whatsThis: "help_text_qbo_default_catalog_item_income_account" }
                    )}
                    {this.qboField(
                        "default_inventory_asset_account",
                        this.state.qboOtherCurrentAssetAccounts?.length ? (
                            <OwSelectOption
                                options={this.state.qboOtherCurrentAssetAccounts}
                                valueProp={"Id"}
                                titleProp={"Name"}
                                fn={this.handleChange}
                                selectedOption={this.state}
                                selectedOptionProp={"qbo_InventoryAssetAccountId"}
                                name={"qbo_InventoryAssetAccountId"}
                                showBlankFirst={true}
                            />
                        ) : (
                            this.qboLoading("loading_default_inventory_asset_account_options")
                        ),
                        { key: "qbo_InventoryAssetAccountId", whatsThis: "help_text_qbo_default_inventory_asset_account" }
                    )}
                    {this.qboField(
                        "default_cogs_account",
                        this.state.qboCOGSAccounts?.length ? (
                            <OwSelectOption
                                options={this.state.qboCOGSAccounts}
                                valueProp={"Id"}
                                titleProp={"Name"}
                                fn={this.handleChange}
                                selectedOption={this.state}
                                selectedOptionProp={"qbo_COGSAccountId"}
                                name={"qbo_COGSAccountId"}
                                showBlankFirst={true}
                            />
                        ) : (
                            this.qboLoading("loading_cogs_account_options")
                        ),
                        { key: "qbo_COGSAccountId", whatsThis: "help_text_qbo_default_cogs_account" }
                    )}
                    {this.qboField(
                        "default_ap_account",
                        this.state.qboAPAccounts?.length ? (
                            <OwSelectOption
                                options={this.state.qboAPAccounts}
                                valueProp={"Id"}
                                titleProp={"Name"}
                                fn={this.handleApChange}
                                selectedOption={this.state.qbo_po_default_ap_account}
                                selectedOptionProp={"Id"}
                                emitObject={true}
                                name={"qbo_po_default_ap_account"}
                                showBlankFirst={true}
                            />
                        ) : (
                            this.qboLoading("loading_ap_account_options")
                        ),
                        { key: "qbo_po_default_ap_account", whatsThis: "help_text_qbo_default_ap_account" }
                    )}
                </div>
                <div className={"qbo-divider"} />
                <div className={"qbo-toggles"}>
                    {this.qboToggleRow("auto_pull_products", "qbo_auto_pull_products", !!this.state.qbo_auto_pull_products)}
                    {this.qboToggleRow("auto_pull_categories", "qbo_auto_pull_categories", !!this.state.qbo_auto_pull_categories, {
                        whatsThis: "help_text_qbo_auto_pull_categories",
                    })}
                    {this.qboToggleRow(
                        "auto_push_inventory_updates",
                        "qbo_push_inventory_updates",
                        !!this.state.qbo_push_inventory_updates
                    )}
                    {this.qboToggleRow("skip_inventory_sync", "qbo_skip_inventory_updates", !!this.state.qbo_skip_inventory_updates, {
                        whatsThis: "help_text_qbo_skip_inventory_sync",
                    })}
                    {this.qboToggleRow(
                        "skip_category_assignment",
                        "qbo_skip_category_assignment",
                        !!this.state.qbo_skip_category_assignment
                    )}
                    {this.qboToggleRow("skip_category_sync", "qbo_skip_category_sync", !!this.state.qbo_skip_category_sync)}
                </div>
            </>
        );

        return this.renderConfigGroup("items", summary, body);
    };

    renderCustomersGroup = () => {
        const summary = this.qboSummary(
            [this.state.qbo_DefaultTermId, this.state.qbo_customer_name_field],
            [!!this.state.qbo_auto_pull_customers, !!this.state.qbo_update_accounts_on_save]
        );

        const body = (
            <>
                <div className={"qbo-field-grid"}>
                    {this.qboField(
                        "default_sale_terms",
                        this.state.qboTermOptionsLoaded ? (
                            <OwSelectOption
                                options={this.state.qboTermOptions}
                                valueProp={"Id"}
                                titleProp={"Name"}
                                fn={this.handleChange}
                                selectedOption={this.state}
                                selectedOptionProp={"qbo_DefaultTermId"}
                                name={"qbo_DefaultTermId"}
                                showBlankFirst={true}
                            />
                        ) : (
                            this.qboLoading("loading_sales_term_options")
                        ),
                        { key: "qbo_DefaultTermId", whatsThis: "help_text_qbo_default_sale_terms" }
                    )}
                    {this.qboField(
                        "customer_name_field",
                        <OwSelectOption
                            options={this.qboCustomerNameFieldOptions}
                            valueProp={"value"}
                            titleProp={"title"}
                            fn={this.handleChange}
                            selectedOption={this.state}
                            selectedOptionProp={"qbo_customer_name_field"}
                            name={"qbo_customer_name_field"}
                        />,
                        { key: "qbo_customer_name_field", whatsThis: "help_text_qbo_customer_name_field" }
                    )}
                </div>
                <div className={"qbo-divider"} />
                <div className={"qbo-toggles"}>
                    {this.qboToggleRow("auto_pull_customers", "qbo_auto_pull_customers", !!this.state.qbo_auto_pull_customers)}
                    {this.qboToggleRow(
                        "auto_update_accounts_on_save",
                        "qbo_update_accounts_on_save",
                        !!this.state.qbo_update_accounts_on_save
                    )}
                </div>
            </>
        );

        return this.renderConfigGroup("customers", summary, body);
    };

    renderOrdersGroup = () => {
        const hasRepGroups = !!this.props.supplierModel.has_rep_groups;
        // The legacy rep-group custom field only applies to non-Enhanced businesses; Enhanced ones route it
        // through Custom Field Mappings instead.
        const showRepGroup = hasRepGroups && !this.isEnhancedCustomFields();

        const summary = this.qboSummary(
            [
                hasRepGroups ? this.state.qbo_SalesRepCustomFieldId : null,
                showRepGroup ? this.state.qbo_RepGroupCustomFieldId : null,
                this.state.qbo_CustomFieldValueOne,
                this.state.qbo_CustomFieldValueTwo,
                this.state.qbo_CustomFieldValueThree,
            ].filter((value) => value !== null),
            []
        );

        const body = (
            <div className={"qbo-field-grid"}>
                {hasRepGroups
                    ? this.qboField(
                          "sales_rep_custom_field",
                          <OwSelectOption
                              options={this.state.qboCustomSalesFields}
                              valueProp={"Id"}
                              titleProp={"Name"}
                              fn={this.changeSalesRepField}
                              selectedOption={this.state}
                              selectedOptionProp={"qbo_SalesRepCustomFieldId"}
                              name={"qbo_SalesRepCustomFieldName"}
                              showBlankFirst={true}
                          />,
                          { key: "qbo_SalesRepCustomFieldId", whatsThis: "help_text_sales_rep_custom_field" }
                      )
                    : null}
                {showRepGroup
                    ? this.qboField(
                          "rep_group_custom_field",
                          <OwSelectOption
                              options={this.state.qboCustomSalesFields}
                              valueProp={"Id"}
                              titleProp={"Name"}
                              fn={this.changeRepGroupField}
                              selectedOption={this.state}
                              selectedOptionProp={"qbo_RepGroupCustomFieldId"}
                              name={"qbo_RepGroupCustomFieldName"}
                              showBlankFirst={true}
                          />,
                          { key: "qbo_RepGroupCustomFieldId", whatsThis: "help_text_rep_group_custom_field" }
                      )
                    : null}
                {this.qboField(
                    "order_entry_custom_field_one",
                    <OwSelectOption
                        name={"qbo_CustomFieldValueOne"}
                        titleProp={"Name"}
                        valueProp={"Name"}
                        options={this.state.qboCustomSalesFields}
                        fn={this.handleChange}
                        selectedOption={this.state}
                        selectedOptionProp={"qbo_CustomFieldValueOne"}
                    />,
                    { key: "qbo_CustomFieldValueOne" }
                )}
                {this.qboField(
                    "order_entry_custom_field_two",
                    <OwSelectOption
                        name={"qbo_CustomFieldValueTwo"}
                        titleProp={"Name"}
                        valueProp={"Name"}
                        options={this.state.qboCustomSalesFields}
                        fn={this.handleChange}
                        selectedOption={this.state}
                        selectedOptionProp={"qbo_CustomFieldValueTwo"}
                    />,
                    { key: "qbo_CustomFieldValueTwo" }
                )}
                {this.qboField(
                    "order_entry_custom_field_three",
                    <OwSelectOption
                        name={"qbo_CustomFieldValueThree"}
                        titleProp={"Name"}
                        valueProp={"Name"}
                        options={this.state.qboCustomSalesFields}
                        fn={this.handleChange}
                        selectedOption={this.state}
                        selectedOptionProp={"qbo_CustomFieldValueThree"}
                    />,
                    { key: "qbo_CustomFieldValueThree" }
                )}
                {this.state.catalog_id
                    ? this.qboField(
                          "shipping_item",
                          <Typeahead
                              isSelectableFn={() => true}
                              typeaheadApiFn={this.shippingItemLookup}
                              typeaheadItems={this.state.foundShippingItems}
                              titleProp={"name"}
                              subTitleProp={"sku"}
                              selectedItemFn={this.handleShippingItemSelect}
                              selectedItem={this.state.selectedShippingItem}
                              selectedItemTitleProp={"name"}
                              placeholder={"shipping_item"}
                              clearTypeahead={this.state.clearShippingItem}
                              clearTypeaheadCallback={this.clearShippingItem}
                          />,
                          { key: "shipping_item" }
                      )
                    : null}
            </div>
        );

        return this.renderConfigGroup("orders", summary, body);
    };

    renderEstimatesGroup = () => {
        const summary = this.qboSummary(
            [],
            [
                !!this.state.qbo_use_ow_quote_num_for_estimate,
                !!this.state.qbo_quote_for_est_name,
                !!this.state.qbo_hide_quote_ow_btns,
                !!this.state.qbo_estimate_from_order,
                !!this.state.qbo_est_invoice_auto_ship,
            ]
        );

        const body = (
            <div className={"qbo-toggles"}>
                {this.qboToggleRow(
                    "qbo_use_ow_quote_no_as_estimate_no",
                    "qbo_use_ow_quote_num_for_estimate",
                    !!this.state.qbo_use_ow_quote_num_for_estimate
                )}
                {this.qboToggleRow("qbo_quote_for_est_name", "qbo_quote_for_est_name", !!this.state.qbo_quote_for_est_name)}
                {this.qboToggleRow("qbo_hide_quote_ow_btns", "qbo_hide_quote_ow_btns", !!this.state.qbo_hide_quote_ow_btns)}
                {this.qboToggleRow("qbo_estimate_from_order", "qbo_estimate_from_order", !!this.state.qbo_estimate_from_order)}
                {this.qboToggleRow("qbo_est_invoice_auto_ship", "qbo_est_invoice_auto_ship", !!this.state.qbo_est_invoice_auto_ship)}
            </div>
        );

        return this.renderConfigGroup("estimates", summary, body);
    };

    renderInvoicesGroup = () => {
        const isEnhanced = this.isEnhancedCustomFields();
        const loadingPoOptions = isEnhanced ? this.state.getCustomFieldDefinitionsActive : this.state.getCustomFieldsActive;
        const poFieldOptions = isEnhanced ? this.state.qboPOFieldOptions : this.state.qboCustomSalesFields;

        const summary = this.qboSummary(
            [
                this.state.qbo_POCustomFieldId,
                this.state.qbo_invoice_default_date,
                this.state.qbo_invoice_default_ship_date,
                this.state.qbo_invoice_memo,
                this.state.qbo_DefaultShipMethodRefValue,
                ...(this.state.qbo_pull_assign_rep_user ? [this.state.qbo_pull_rep_user_target] : []),
            ],
            [
                !!this.state.qbo_ow_num_as_invoice_ref,
                !!this.state.qbo_AllowAchPayments,
                !!this.state.qbo_grouped_invoices,
                !!this.state.qbo_pull_assign_rep_user,
                !!this.state.qbo_UsingAutoSalesTax,
            ]
        );

        const body = (
            <>
                <div className={"qbo-field-grid"}>
                    {this.qboField(
                        "po_invoice_custom_field",
                        loadingPoOptions ? (
                            this.qboLoading("loading_custom_sales_fields")
                        ) : (
                            <OwSelectOption
                                options={poFieldOptions}
                                valueProp={"Id"}
                                titleProp={"Name"}
                                fn={this.handleChange}
                                selectedOption={this.state}
                                selectedOptionProp={"qbo_POCustomFieldId"}
                                name={"qbo_POCustomFieldId"}
                                showBlankFirst={true}
                            />
                        ),
                        { key: "qbo_POCustomFieldId", whatsThis: "help_text_qbo_po_invoice_custom_field" }
                    )}
                    {this.qboField(
                        "default_invoice_date_field",
                        <OwSelectOption
                            name={"qbo_invoice_default_date"}
                            titleProp={"title"}
                            valueProp={"value"}
                            fn={this.handleChange}
                            translateTitle={true}
                            selectedOption={this.state}
                            selectedOptionProp={"qbo_invoice_default_date"}
                            options={this.qboInvoiceDateFieldOptions}
                        />,
                        { key: "qbo_invoice_default_date", whatsThis: "help_text_qbo_default_invoice_date_field" }
                    )}
                    {this.qboField(
                        "default_invoice_ship_date_field",
                        <OwSelectOption
                            name={"qbo_invoice_default_ship_date"}
                            titleProp={"title"}
                            valueProp={"value"}
                            translateTitle={true}
                            fn={this.handleChange}
                            selectedOption={this.state}
                            selectedOptionProp={"qbo_invoice_default_ship_date"}
                            options={this.qboInvoiceDateFieldOptions}
                        />,
                        { key: "qbo_invoice_default_ship_date", whatsThis: "help_text_qbo_default_invoice_ship_date_field" }
                    )}
                    {this.qboField(
                        "default_invoice_memo",
                        <OwTextArea value={this.state.qbo_invoice_memo} name={"qbo_invoice_memo"} fn={this.handleChange} />,
                        { key: "qbo_invoice_memo" }
                    )}
                    {this.qboField(
                        "default_ship_via",
                        <OwInputWrapper
                            name={"qbo_DefaultShipMethodRefValue"}
                            value={this.state.qbo_DefaultShipMethodRefValue || ""}
                            isSmall={true}
                            fn={this.handleChange}
                        />,
                        { key: "qbo_DefaultShipMethodRefValue" }
                    )}
                    {this.state.qbo_grouped_invoices
                        ? this.qboField(
                              "grouped_invoice_type",
                              <OwSelectOption
                                  options={[
                                      { value: QBOGroupedInvoiceTypeEnum.STANDARD, title: "standard" },
                                      { value: QBOGroupedInvoiceTypeEnum.SUM_BY_ORDER, title: "sum_by_order" },
                                      { value: QBOGroupedInvoiceTypeEnum.GROUPED_BY_DAY, title: "group_by_day" },
                                  ]}
                                  translateTitle={true}
                                  selectedOption={this.state}
                                  selectedOptionProp={"qbo_grouped_invoice_type"}
                                  titleProp={"title"}
                                  valueProp={"value"}
                                  fn={this.handleChange}
                                  name={"qbo_grouped_invoice_type"}
                              />,
                              { key: "qbo_grouped_invoice_type" }
                          )
                        : null}
                </div>
                <div className={"qbo-divider"} />
                <div className={"qbo-toggles"}>
                    {this.qboToggleRow("use_ow_num_as_invoice_ref", "qbo_ow_num_as_invoice_ref", !!this.state.qbo_ow_num_as_invoice_ref)}
                    {this.qboToggleRow("allow_ach_payments", "qbo_AllowAchPayments", !!this.state.qbo_AllowAchPayments)}
                    {this.qboToggleRow("qbo_grouped_invoices", "qbo_grouped_invoices", !!this.state.qbo_grouped_invoices)}
                    {this.qboToggleRow("qbo_pull_assign_rep_user", "qbo_pull_assign_rep_user", !!this.state.qbo_pull_assign_rep_user)}
                    {this.qboField(
                        "qbo_invoice_rep_assignment",
                        <OwSelectOption
                            id="qbo_pull_rep_user_target"
                            name="qbo_pull_rep_user_target"
                            options={qboRepAssignmentOptions}
                            titleProp="title"
                            valueProp="value"
                            translateTitle={true}
                            showBlankFirst={false}
                            selectedOption={this.state}
                            selectedOptionProp="qbo_pull_rep_user_target"
                            isDisabled={!this.state.qbo_pull_assign_rep_user}
                            fn={this.handleChange}
                        />,
                        { key: "qbo_pull_rep_user_target", help: "qbo_invoice_rep_assignment_help", htmlFor: "qbo_pull_rep_user_target" }
                    )}
                    {this.qboToggleRow("using_auto_sales_tax", "qbo_UsingAutoSalesTax", !!this.state.qbo_UsingAutoSalesTax, {
                        whatsThis: "help_text_qbo_using_auto_sales_tax",
                    })}
                    {this.props.supplierModel.sales_tax_config?.shippingTaxable
                        ? this.qboToggleRow(
                              "tax_on_shipping_adjustment",
                              "qbo_TaxOnShippingAdjustment",
                              !!this.state.qbo_TaxOnShippingAdjustment,
                              { whatsThis: "tax_on_shipping_adjustment_tooltip" }
                          )
                        : null}
                </div>
            </>
        );

        return this.renderConfigGroup("invoices", summary, body);
    };

    renderMappingsGroup = () => {
        const supplierIntegrations: any = this.props.supplierModel.Supplier_Integration || {};
        const count = this.state.qboCustomFieldMappings.length;

        const summary = (
            <span>
                {count} <OwLabel title={count === 1 ? "mapping" : "mappings"} noBottomMargin={true} />
            </span>
        );

        const body = (
            <CustomFieldMappings
                definitions={this.getInvoiceApplicableDefinitions(this.state.qboCustomFieldDefinitions)}
                mappableFields={this.state.qboMappableFields}
                existingMappings={this.state.qboCustomFieldMappings}
                isEnhanced={this.isEnhancedCustomFields()}
                reservedDefinitions={[
                    { id: supplierIntegrations.qbo_POCustomFieldId, usedByLabel: "po_invoice_custom_field" },
                    { id: supplierIntegrations.qbo_SalesRepCustomFieldId, usedByLabel: "sales_rep_custom_field" },
                    { id: supplierIntegrations.qbo_RepGroupCustomFieldId, usedByLabel: "rep_group_custom_field" },
                ].filter((entry): entry is { id: string; usedByLabel: string } => !!entry.id)}
                saving={this.state.saveCustomFieldMappingsActive}
                onSave={this.saveCustomFieldMappings}
            />
        );

        return this.renderConfigGroup("mappings", summary, body);
    };

    renderOtherGroup = () => {
        const summary = this.qboSummary([], [!!this.state.qbo_using_classes]);

        const body = (
            <>
                <div className={"qbo-toggles"}>
                    {this.qboToggleRow("using_classes", "qbo_using_classes", !!this.state.qbo_using_classes)}
                </div>
                {this.props.showHiddenFeatures ? (
                    <>
                        <div className={"qbo-divider"} />
                        <div className={"d-flex flex-wrap gap-2"}>
                            <OwButton title={"get_preferences"} fn={this.getPreferences} />
                            <OwButton title={"get_tax_codes"} fn={this.getTaxCodes} />
                            <OwButton title={"force_custom_field_one_active"} fn={() => this.forceCustomFieldActive(1)} />
                            <OwButton title={"force_custom_field_two_active"} fn={() => this.forceCustomFieldActive(2)} />
                            <OwButton title={"force_custom_field_three_active"} fn={() => this.forceCustomFieldActive(3)} />
                            <OwButton title={"get_custom_field_definitions"} fn={this.logCustomFieldDefinitions} />
                        </div>
                    </>
                ) : null}
            </>
        );

        return this.renderConfigGroup("other", summary, body);
    };

    render() {
        let supplierIntegrations: any = {};

        if (!_.isNil(this.props.supplierModel)) {
            supplierIntegrations = this.props.supplierModel.Supplier_Integration || {};
        }

        let logo = quickbooksLogo;

        if (this.props.isMainViewLight) {
            logo = quickbooksLightLogo;
        }

        const hasQbo = !!supplierIntegrations.has_qbo;

        return (
            <div className="QuickbooksConnect">
                <OwAccordion
                    hideChevron={!hasQbo}
                    leftImage={logo}
                    leftImageHeight={35}
                    leftImageAlt={"QuickBooks Online"}
                    titleClick={hasQbo}
                    rightElem={
                        <div className={"ms-auto"}>
                            {hasQbo ? (
                                <OwBadge title={"connected"} leftIconClass={"fas fa-check"} bgColor={"bg-success"} />
                            ) : (
                                <div>
                                    <OwToggle
                                        name={"enable_payments"}
                                        label={"enable_payments"}
                                        active={this.state.enable_payments}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />

                                    <div className={"mt-2"}>
                                        <button className="btn-qb pointer" onClick={this.startQBConnect}>
                                            <img src={qbBtnDefault} alt="Quickbooks Connect" height={40} />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    }>
                    {hasQbo ? (
                        <div className={"qbo-config"}>
                            {this.renderConnectionDetails()}
                            {this.renderConfigToolbar()}
                            {this.renderSetupGroup()}
                            {this.renderItemsGroup()}
                            {this.renderCustomersGroup()}
                            {this.renderOrdersGroup()}
                            {this.renderEstimatesGroup()}
                            {this.renderInvoicesGroup()}
                            {this.renderMappingsGroup()}
                            {this.renderOtherGroup()}
                        </div>
                    ) : null}
                </OwAccordion>
            </div>
        );
    }
}

export default QuickbooksConnect;
